module.exports = __webpack_public_path__ + "static/img/octo.9586fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integrations/octo/octo.png
// module id = 375
// module chunks = 0